import './axios'
import router from '../router'
import store from '../store'
import { registerPrimeVue } from './primevue'

export const registerPlugins = (app) => {
    app.use(store)
        .use(router)
        .provide('router', router)
    registerPrimeVue(app)
}